import { Button, ButtonLink } from '@getslot/ui-web/button'
import { Loading, Notice } from '@getslot/ui-web/notice'
import type { ReactNode } from 'react'
import { WelcomePage } from '../../features/welcome/welcome-page'
import { MINI_APP_URL } from '../config'
import { useAuth } from './auth-provider'

/** Пускает к экранам только вошедшего; остальным — вход, закрытая бета или «нет связи». */
export function AuthGate({ children }: { children: ReactNode }) {
  const { status, retry } = useAuth()

  switch (status) {
    case 'loading':
      return <Loading label="Входим" />
    case 'guest':
      return <WelcomePage />
    case 'beta_closed':
      return (
        <Notice
          title="Пока только по приглашению"
          actions={
            <ButtonLink variant="ink" href={MINI_APP_URL}>
              Открыть бота
            </ButtonLink>
          }
        >
          GetSlot сейчас в закрытой бете. Напишите в бот, и мы добавим вас, как только откроем места.
        </Notice>
      )
    case 'unavailable':
      return (
        <Notice
          title="Нет связи"
          actions={
            <Button variant="cta" onClick={retry}>
              Попробовать ещё раз
            </Button>
          }
        >
          Сервер не отвечает. Проверьте интернет или зайдите чуть позже.
        </Notice>
      )
    case 'ready':
      return children
  }
}
